export default function FiltroCursoPerfil({
  filterText,
  setFilterText,
  selectedCategory,
  setSelectedCategory,
  onFilterClick, // nuevo callback
}) {
  const handleFilter = (category) => {
    setSelectedCategory(category);
    if (onFilterClick) {
      onFilterClick(); // Cierra el modal
    }
  };

  return (
    <div className="perfil-info-2-busqueda-filtros">
      <div className="barra-busqueda-2">
        <img
          className="search-3-1"
          src="../images/search-3-1_2.svg"
          alt=""
          loading="lazy"
        />
        <input
          id="input-busqueda-2"
          className="barra-busqueda-texto-2"
          type="search"
          placeholder="Buscar"
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          style={{ flex: 1, boxSizing: "border-box" }}
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck="false"
        />
      </div>
      <div className="filtros-2">
        <div
          className={`boton-filtros-perfil${
            selectedCategory === "TODOS" ? "-seleccionado" : ""
          }`}
          onClick={() => handleFilter("TODOS")}
        >
          <p className="filtro-todos-texto">Todos</p>
        </div>
        <div
          className={`boton-filtros-perfil${
            selectedCategory === "EN_CURSO" ? "-seleccionado" : ""
          }`}
          onClick={() => handleFilter("EN_CURSO")}
        >
          <i className="fi fi-rs-pencil component-6"></i>
          <p className="boton-filtros-perfil-texto">En Curso</p>
        </div>
        {/*
        <div
          className={`boton-filtros-perfil${selectedCategory === "CERTIFICADO" ? "-seleccionado" : ""}`}
          onClick={() => handleFilter("CERTIFICADO")}
        >
          <i className="fi fi-rs-diploma component-6"></i>
          <p className="boton-filtros-perfil-texto">Certificado</p>
        </div>
          */}
        <div
          className={`boton-filtros-perfil${
            selectedCategory === "INCONCLUSO" ? "-seleccionado" : ""
          }`}
          onClick={() => handleFilter("INCONCLUSO")}
        >
          <i className="fi fi-bs-ban component-6"></i>
          <p className="boton-filtros-perfil-texto">Inconcluso</p>
        </div>
      </div>
    </div>
  );
}
